<template>
  <div class="federated-search-facet-date-filter">
    <div class="federated-search-facet-date-filter__filters-group-title">
      <h3>Date</h3>
      <button
        :aria-label="`${collapsed ? 'Show' : 'Hide'} Date Filters`"
        @click="collapsed = !collapsed"
      >
        <svg aria-hidden="true" role="img">
          <use
            :xlink:href="
              `/app/themes/ahc/src/assets/images/icons.svg#${
                collapsed ? 'plus' : 'minus'
              }`
            "
          />
        </svg>
      </button>
    </div>
    <div v-if="!collapsed">
      <button
        class="federated-search-facet-date-filter__filters-group-year"
        type="button"
        v-for="(years, index) in [5, 10, 25]"
        @click="updateDateRange(years)"
        v-bind:key="index"
      >
        Last {{ years }} Years
      </button>
      <h3
        class="federated-search-facet-date-filter__filters-group-year-range-title"
      >
        Custom Year Range
      </h3>
      <input
        maxLength="4"
        aria-label="Date Range Start"
        autocomplete="off"
        v-model="visibleYearRangeStart"
        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
        @keydown.enter="updateYearRangeFilterValues()"
        class="federated-search-facet-date-filter__filters-group-year-input"
      />
      to
      <input
        maxLength="4"
        aria-label="Date Range End"
        autocomplete="off"
        v-model="visibleYearRangeEnd"
        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
        @keydown.enter="updateYearRangeFilterValues()"
        class="federated-search-facet-date-filter__filters-group-year-input"
      />
      <button
        class="button federated-search-facet-date-filter__filters-group-submit-button"
        type="button"
        ref="submitButton"
        @keydown.tab="handleTabOffSubmit"
        @click="updateYearRangeFilterValues()"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'ahc-federated-search-facet-date-filter',
  components: {
  },
  methods: {
    updateDateRange(years) {
        const currentYear = new Date().getFullYear();
        this.visibleYearRangeEnd = currentYear;
        this.visibleYearRangeStart = currentYear - years;
        this.updateYearRangeFilterValues();
      },
      updateYearRangeFilterValues() {
        this.localYearRangeEnd = this.visibleYearRangeEnd;
        this.localYearRangeStart = this.visibleYearRangeStart;
        this.$emit('update:yearRangeEnd', this.visibleYearRangeEnd);
        this.$emit('update:yearRangeStart', this.visibleYearRangeStart);
        this.search({});
      },
  },
  props: {
    search: {
      type: Function,
      required: true
    },
    yearRangeStart: {
      type: String,
      required: false,
    },
    yearRangeEnd: {
      type: String,
      required: false,
    },
    handleTabOffSubmit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      collapsed: false,
      visibleYearRangeStart: null,
      visibleYearRangeEnd: null,
    }
  },
  computed: {
  },
  mounted() {
    if (this.yearRangeEnd) {
      this.localYearRangeEnd = this.yearRangeEnd;
      this.visibleYearRangeEnd = this.yearRangeEnd;
    }
    if (this.yearRangeStart) {
      this.localYearRangeStart = this.yearRangeStart;
      this.visibleYearRangeStart = this.yearRangeStart;
    }
  },
  watch: {
    yearRangeEnd(newVal) {
      console.log({newVal});
      this.localYearRangeEnd = newVal;
      this.visibleYearRangeEnd = newVal;
    },
    yearRangeStart(newVal) {
      this.localYearRangeStart = newVal;
      this.visibleYearRangeStart = newVal;
    }
  }

}
</script>

<style lang="scss">
@import "federated-search-facet-date-filter";
</style>
